<script setup lang="ts">
import { defineAsyncComponent } from 'vue';
import { cn } from '@/lib/utils';

const props = defineProps<{
  name: string;
}>();

const icon = defineAsyncComponent(() => import(`../../assets/images/Misc/icons/${props.name}.svg`));
</script>

<template>
  <component :class="cn('shrink-0', $attrs.class ?? '')" :is="icon" :key="icon" />
</template>
